import { http } from './http'

// 获取用户信息
export const getUserInfo = (token) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user',
        method: 'get',
        alert: false,
        ...(token ? { token: token } : {})
        // query: params,
    })